import { render, staticRenderFns } from "./ReceiptSearch.vue?vue&type=template&id=3afc2ae0&scoped=true"
import script from "./ReceiptSearch.vue?vue&type=script&lang=js"
export * from "./ReceiptSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc2ae0",
  null
  
)

export default component.exports